import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    // send_page_view: false — initialize 의 gtag('config') 가 보내는 자동 page_view 를 끈다.
    // 끄지 않으면 자동 1회(제목=document.title) + trackPageView 1회로 같은 화면이 두 이름으로 중복 집계된다.
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gtagOptions: { send_page_view: false },
    });
    console.log("Google Analytics Initialized");
  } else {
    console.warn("Google Analytics Measurement ID is missing");
  }
};

// 다국어 서비스라 document.title 을 그대로 쓰면 GA에서 같은 화면이 언어 수만큼 쪼개진다.
// 페이지 이름은 언어 무관한 고정값으로 보내고, 언어는 content_language 파라미터로 분리한다.
export const trackPageView = (path: string, language?: string) => {
  ReactGA.send({
    hitType: "pageview",
    page: path,
    title: "Consultation",
    content_language: language,
  });
};

export const trackEvent = (
  category: string,
  action: string,
  label?: string,
) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};
